import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import CustomDrawer from './components/Drawer';
import Header from './components/Header';
import backgroundImage from '../../../assets/background.png';
import { RADIUS } from './config-layout';
import checkAuthController from './controllers/check-auth.controller';
import useScreenWidth from '../../hooks/use-page-width';

const DashboardLayout = ({ children }: any) => {
  const checkAuthCtrl = checkAuthController();
  const width = useScreenWidth();

  const [open, setOpen] = useState(true);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  useEffect(() => {
    checkAuthCtrl.handleCheckAuthHomePage();
  }, []);

  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box sx={{ width: '100%', backgroundColor: 'transparent' }}>
        <Header />
      </Box>

      <Box sx={{ display: 'flex', overflow: 'auto', height: 'calc(100vh - 48px)' }}>

        {width > 600 && <CustomDrawer open={open} toggleDrawer={toggleDrawer} />}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: '100%',
            overflow: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            scrollbarWidth: 'none',
            '-ms-overflow-style': 'none',
          }}
        >
          <Box sx={{ height: '100%' }}>
            <Box sx={{ px: width > 600 ? 3 : 0, height: '100%' }}>
              <Box
                sx={{
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                  borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                  borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                  borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                  paddingBottom: "10px",
                }}
              >
                {children}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
